import { Box, Grid } from "@mui/material";
import {
  CustomTable,
  DateTimeDisplay,
  ModalPreviewDocument,
  SearchTextInput,
  SelectInput,
} from "components";
import moment from "moment-timezone";
import { useState } from "react";

const SupportingDocument = ({
  dataTable,
  queryParams,
  handleChangeQueryParams,
  isLoading,
}) => {
  const [modalPreview, setModalPreview] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});

  return (
    <Box>
      <Grid container justifyContent="space-between" my="16px">
        <Grid item>
          <SearchTextInput
            placeholder="Search"
            value={queryParams?.search}
            onChange={e => handleChangeQueryParams(e?.target?.value, "search")}
          />
        </Grid>
        <Grid item>
          <SelectInput
            options={optionSort}
            optionKey="key"
            optionLabel="value"
            value={queryParams?.sort}
            onChange={e => handleChangeQueryParams(e?.target?.value, "sort")}
            width={200}
          />
        </Grid>
      </Grid>
      <CustomTable
        isLoading={isLoading}
        columnTable={columnTable}
        data={dataTable}
        isHaveAction
        handleView={item => {
          setModalPreview(true);
          setSelectedFile(item);
        }}
      />
      <ModalPreviewDocument
        open={modalPreview}
        onClose={() => setModalPreview(false)}
        preload={selectedFile}
      />
    </Box>
  );
};

const optionSort = [
  {
    key: "-created_at",
    value: "Latest",
  },
  {
    key: "created_at",
    value: "Oldest",
  },
];
const columnTable = [
  {
    name: "filename",
    title: "Document Title",
    renderText: item => item || "-",
  },
  {
    name: "all",
    title: "Uploaded At",
    renderText: item => (
      <DateTimeDisplay
        date={moment(`${item?.created_date} ${item?.created_time}`)}
      />
    ),
  },
];

export default SupportingDocument;
